import { IconAlert } from '@consta/icons/IconAlert'
import { IconAllDone } from '@consta/icons/IconAllDone'
import { Placeholder } from '@core/components'
import type { MultipartUploadedFile } from '@core/core/types'
import type { FC } from 'react'

import { css, LabeledTimer } from '../../Common'

type LoadingProps = {
  file: MultipartUploadedFile
}

export const Loading: FC<LoadingProps> = ({ file }) => {
  const progress = Math.floor(file.progress)
  const loadingStatus = file.statuses?.loading ?? 'notstarted'

  const content = () => {
    switch (loadingStatus) {
      case 'succeeded':
        return (
          <Placeholder
            data-testid="loading-complete"
            icon={<IconAllDone className={css.iconStyle} size="l" view="success" />}
            title="Маркеры загружены в проект"
          />
        )
      case 'failed':
        return (
          <Placeholder
            icon={<IconAlert className={css.iconStyle} size="l" view="alert" />}
            title="Не удалось загрузить маркеры"
            description={file.error}
          />
        )
      case 'inprogress':
        return <LabeledTimer progress={progress} text="Загружаем..." />
      default:
        return null
    }
  }

  return (
    <div data-testid="import-markers-loading" className={css.loadingFrame}>
      {content()}
    </div>
  )
}
